/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'delete': {
    width: 14,
    height: 14,
    viewBox: '0 0 14 14',
    data: '<g transform="translate(-1 -1)" _fill="#566473" fill-rule="evenodd"><rect pid="0" transform="rotate(45 8 8)" x="7" y="-1" width="2" height="18" rx="1"/><rect pid="1" transform="rotate(-45 8 8)" x="7" y="-1" width="2" height="18" rx="1"/></g>'
  }
})
